import { appName, githubOAuth, oidc } from "./branding.js";
/**
 * Browser-safe configuration for git commit complexity analysis
 *
 * This configuration excludes Node.js-specific features (process.env, file paths)
 * and is suitable for use in browser environments.
 *
 * Note: Many fields like `checkout`, `store`, and `database` are not applicable
 * in browser contexts but are included for type compatibility.
 */
export function getBrowserConfig() {
    return {
        // List of repositories to analyze
        // In browser context, this would typically come from UI input or API
        repos: [
            {
                owner: "getdevpulse",
                repo: "monorepo",
                localPath: "", // Not used in browser
            },
        ],
        // Time range for analysis
        // Default to 7 days, can be overridden by UI controls
        time: {
            kind: "lastDays",
            days: 7,
        },
        // Enable verbose logging (browser console)
        verbose: false, // Default to false in browser to reduce console noise
        // Note: The following fields are Node.js-specific and not applicable in browser:
        // - checkout: Repository cloning not available in browser
        // - githubToken: Should never be exposed to browser (use backend API)
        // - store: File system not available in browser
        // - database: SQLite not available in browser (use IndexedDB instead)
        // Author mapping configuration (read-only in browser)
        authorMapping: {
            githubLookup: false, // Browser should fetch from API, not GitHub directly
            enrichUnknowns: false,
            abortOnRateLimit: false,
            migrateExisting: false,
        },
        // Team mapping configuration (read-only in browser)
        teamMapping: {
            updateTeamsFile: false, // No file system in browser
        },
        // GitHub metrics collection (read-only in browser)
        githubMetrics: {
            enabled: false, // Browser should fetch from API
            collectPRs: false,
            collectIssues: false,
            collectReleases: false,
        },
        // User profile sync configuration (not applicable in browser)
        userSync: {
            autoFetchNew: false, // Browser fetches from API
        },
    };
}
/**
 * Export the browser-safe configuration
 *
 * Note: This returns a Partial<AnalysisConfig> because many fields
 * (checkout, store, database, githubToken) are not applicable in browser context.
 */
export const browserConfig = getBrowserConfig();
/**
 * Export the application name from branding configuration
 * This is used in the browser UI (e.g., UIShell app name)
 */
export { appName };
/**
 * Export OIDC configuration from branding
 * Leave authority and clientId empty to disable OIDC authentication
 */
export const oidcConfig = oidc;
/**
 * Export GitHub OAuth configuration from branding
 * Leave clientId empty to disable GitHub OAuth
 */
export const githubOAuthConfig = githubOAuth;
